module.exports = {
  productionTip: process.env.VUE_APP_productionTip,
  devTools: process.env.VUE_APP_devTools,
  api: {
    baseUrl: process.env.VUE_APP_BASEURL,
  },
}
